module.exports = __webpack_public_path__ + "img/access-google-ads-lang.d7825e51.png";